import { setItem } from "../../utils/storageHelper";
export const setLicense = async (licenseData) => {
    await setItem("license", licenseData);
}